<template>
  <div class="roleTreeBox">
    <el-input placeholder="搜索" prefix-icon="el-icon-search" v-model="filterText"> </el-input>
    <div class="roleTreeC">
      <dsf-virtual-scroll scroll-x class="roleTree">
        <el-tree
          ref="tree"
          show-checkbox
          default-expand-all
          check-on-click-node
          v-loading="loading"
          :expand-on-click-node="false"
          :data="treeData"
          :node-key="nodeKey"
          :props="defaultProps"
          :empty-text="loading ? '' : '暂无数据'"
          :filter-node-method="filterNode"
        >
          <slot slot-scope="{ node }">
            <span>
              <i class="myIcon iconfont icon-zhuhutiaocha"></i>
              {{ node.label }}
            </span>
          </slot>
        </el-tree>
      </dsf-virtual-scroll>
    </div>
  </div>
</template>

<script>
export default {
  name: "roleTree",
  data() {
    return {
      defaultProps: {
        children: "children",
        label: "_name",
      },
      nodeKey: "_id",
      treeData: [],
      loading: true,
      filterText: "",
    };
  },
  created() {
    this.loadData();
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  methods: {
    loadData() {
      this.$http
        .get("dp/oua/findRoleTree", { keyWord: "" })
        .done(({ data, success, msg }) => {
          if (success) {
            this.treeData = data;
          } else {
            dsf.layer.message(msg, false);
          }
        })
        .error(() => {
          dsf.layer.message("获取角色请求异常", false);
        })
        .always(() => {
          this.loading = false;
        });
    },
    getResult() {
      return this.$refs.tree.getCheckedNodes();
    },
    clearResult(list) {
      _.forEach(list, (item) => {
        this.$refs.tree.setChecked(item, false, false);
      });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data._name.indexOf(value) !== -1;
    },
  },
};
</script>
